import React from 'react';

import { formatMoney } from '@betterment/core';
import { Icon, ListRow, Text } from '@betterment/samba-react';

import { LegacyTransferTypeEnum, type RecurringTransactionConfig } from './types';
import { configFrequencyCopy } from './utils';

type Props = {
  config: RecurringTransactionConfig;
  isWithdrawal: (sourceLegacySubAccountId: number) => boolean;
};

const isMoneyOutflow = (
  config: RecurringTransactionConfig,
  isWithdrawal: (sourceLegacySubAccountId: number) => boolean
): boolean => {
  if (config.legacyTransferType === LegacyTransferTypeEnum.Withdrawal) {
    return true;
  }
  if (config.legacyTransferType === LegacyTransferTypeEnum.Deposit) {
    return false;
  }
  if (config.source.__typename === 'CashAccount' || config.source.__typename === 'ManagedSubAccount') {
    return isWithdrawal(config.source.legacySubAccountId);
  }
  return false;
};

export const RecurringTransactionsConfig: React.FC<Props> = ({ config, isWithdrawal }) => {
  const isOutflow = isMoneyOutflow(config, isWithdrawal);
  const iconName = isOutflow ? 'ArrowCircleMinus' : 'ArrowCirclePlus';
  const transactionDirection = isOutflow ? `to ${config.destinationName}` : `from ${config.sourceName}`;

  return (
    <>
      <ListRow.LeadingAsset>
        <Icon name={iconName} size="small" />
      </ListRow.LeadingAsset>
      <ListRow.LeadingContent>
        <Text>{`${formatMoney(config.amount)} ${transactionDirection}`}</Text>
        <Text variant="text50" color="text.weak">
          {configFrequencyCopy(config)}
        </Text>
      </ListRow.LeadingContent>
    </>
  );
};
